import styled from 'styled-components';

export const Tech = styled.div`
    font-size: 2.5vw;
    font-family: Monospaced, monospace;
    text-align: center;
    color: #ddd;
`;

export const TechContainer = styled.div`
    width: 16.666%;
    height: 16.666vw;
    color: white;
    background-color: #0F4C75;
    border: solid white 1px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateY(40px);
`;

export const Technologies = styled.div`
    flex-direction: row;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;